export const DIRS_LAYER_PREFIX = '@DIRS/INTELLIGENT_LAYER';
